import { ReactElement, createContext, useContext } from "react";
import GetEvents, { ResponseMembrosCheckin } from "../services/getEvents";


export const EventsListContext = createContext<ResponseMembrosCheckin>(null);


export const EventsListProvider = ({children}: { children: ReactElement }) => {
  const context = GetEvents();
  return (
    <>
      <EventsListContext.Provider value={context}>
        {children}
      </EventsListContext.Provider>
    </>
  )
}

export const UseList = () => {
  const context = useContext(EventsListContext);
  return context;
}
